import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap'

import Footer from './Footer'
import ArticlesCard from './ArticlesCard'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

// Firebase
import base from '../base'

class Article extends Component {

    state = {
      recettes: [],
        redirect:false
        }
    
    componentDidMount(){
        //reference ds firebase
    
        this.ref = base.syncState(`/listeRecettes`,{
          context: this,
          state: 'recettes',
          queries: {
            orderByChild: "id",
            limitToLast: 10
          }
        })
    }
    
    componentWillUnmount () {
        //fermer la reference ds firebase
        //la connexion est terminée entre notre state et firebase
        base.removeBinding(this.ref)
        }

        handleCHange = event => {
          const { name, value } = event.target
          this.setState({ [name]: value })
      }
      
        handleSubmit = event => {
          //on gere le form
          event.preventDefault()
          this.props.history.push(`/recherche/${this.state.search}`);
      
        }
    
        setArticles = () => {
        this.setState({
            redirect: true
        })
        }

        setRedirect = () => {
          this.setState({
            redirect: true
          })
        }
          
        handleSubmitFacebbok = () => {
          if (this.state.redirect) {
              window.location.href = "https://www.facebook.com/clubCAPN/";
          }
        }
    
        compare = ( a, b ) => {
        if ( (a)[0].split("-")[1] < (b)[0].split("-")[1] ){
            return 1;
        }
        if ( (a)[0].split("-")[1] > (b)[0].split("-")[1] ){
            return -1;
        }
        return 0;
        }
    
        render () {  

          let articles = []
          Object
          .entries(this.state.recettes)
          .map(key => 
            articles.push(key)
          );
          articles.sort(this.compare)
          console.log(Object.keys(this.state.recettes).length)
        return (
            <>
            <Container fluid>
            <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />
    
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding " >
                        
                              <div className="actu-content">
                                <h1 className="hline"><span>Actualités</span></h1> 
                                {((Object.keys(this.state.recettes).length !== 0)) &&
                                   <ArticlesCard  details={articles}/>
                                  }
                              </div>
                      {/* {((Object.keys(this.state.recettes).length === 0)) &&
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                          <NotFound/>
                      </Col>
                      } */}
                      </Col>
    
    
                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                  <div className={Object.keys(this.state.recettes).length <= 6 ? 'fixed-bottom-footer' : 'fixed-bottom-footer-not'}><Footer /></div>
                  </Col>
                </Col>
              </Row>
            </Container>
          </>
        )
    }
}

export default Article;